import { Alert } from "react-bootstrap";

function Message({ variant, children, className }) {
  return (
    <Alert variant={variant} className={className}>
      {children}
    </Alert>
  );
}

export default Message;
